import React from "react";

import CardSVG from "./svg/CardSVG";
import GiftSVG from "./svg/GiftSVG";
import CalendarSVG from "./svg/CalendarSVG";
import LaptopSVG from "./svg/LaptopSVG";
import SignalSVG from "./svg/SignalSVG";
import CrossSVG from "./svg/CrossSVG";

const CounterTile = ({ className, icon, currency, value, about }) => {
  return (
    <div className={className}>
      <div className="icon">
        <div className="icon-circle">
          {icon === "card" && <CardSVG />}
          {icon === "gift" && <GiftSVG />}
          {icon === "calendar" && <CalendarSVG />}
          {icon === "laptop" && <LaptopSVG />}
          {icon === "signal" && <SignalSVG />}
          {icon === "cross" && <CrossSVG />}
        </div>
      </div>
      <div className="text-box">
        <div className="value">{ currency ? currency + value.toLocaleString() : value}</div>
        <p className="about">{about}</p>
      </div>
    </div>
  );
};

export default CounterTile;
